import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { MiscService } from "app/shared/misc.service";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { catchError, exhaustMap } from "rxjs/operators";
import { FeeSharingService } from "../fee-sharing.service";
import * as feeActions from './fee-sharing.actions';

@Injectable({
    providedIn: 'root'
})

export class FeeEffects {
    constructor(
        private actions$: Actions,
        private feeService: FeeSharingService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

    fetchFeeShare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(feeActions.fetchFeeShare),
      exhaustMap((action) =>
        this.feeService
          .getFeeSharing()
          .pipe(
            exhaustMap((response: any) => [
                feeActions.fetchFeeShareSuccess({ feeShare: response.data }),
            ]),
            catchError((error: HttpErrorResponse) => {
              if(error.status == 400){
                this.toastr.info( 'No Data');
                  return of(feeActions.fetchFeeShareSuccess({ feeShare: [] }))
              }else{
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(feeActions.fetchFeeShareFailed())
              }
            }
            )
          )
      )
    )
  );

  createFeeShare$ = createEffect(() =>
  this.actions$.pipe(
    ofType(feeActions.createFeeShare),
    exhaustMap((action) =>
      this.feeService
        .createFeeSharing(action.feeShareDto)
        .pipe(
          exhaustMap((response: any) => [
              feeActions.createFeeShareSuccess(),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(feeActions.createFeeShareFailed())
          }
          )
        )
    )
  )
);
  updateFeeShare$ = createEffect(() =>
  this.actions$.pipe(
    ofType(feeActions.editFeeShare),
    exhaustMap((action) =>
      this.feeService
        .updateFeeSharing(action.feeShareDto, action.id)
        .pipe(
          exhaustMap((response: any) => [
              feeActions.editFeeShareSuccess(),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(feeActions.editFeeShareFailed())
          }
          )
        )
    )
  )
);
  deleteFeeShare$ = createEffect(() =>
  this.actions$.pipe(
    ofType(feeActions.deleteFeeShare),
    exhaustMap((action) =>
      this.feeService
        .deleteFeeSharing(action.id)
        .pipe(
          exhaustMap((response: any) => [
              feeActions.deleteFeeShareSuccess(),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(feeActions.deleteFeeShareFailed())
          }
          )
        )
    )
  )
);
}